import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from './index';
import { Alert, NotificationSliceType } from '../types/notification';

//const NOTIFICATION_KEY = 'notification';

const resetNotification = {
    status: false,
    msg: '',
    title: '',
    class: '',
    position: '',
}

const initialState: NotificationSliceType = {
    notificationInfo: { ...resetNotification },
    modalErrorStatus: false,
    modalLogin: false,
    modalErrorMessage: '',
    notificationButtonLoad: false,
    modal401: false,
    alerts: [],
    spanErrorMessage: "",
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setNotification: (state, action) => {
            if (state.notificationInfo.status === false) {
                state.notificationInfo = action.payload;
            }
        },
        setResetNotification: (state) => {
            state.notificationInfo = { ...resetNotification }
        },
        setModalErrorStatus: (state, action) => {
            state.modalErrorStatus = action.payload
        },
        setModalErrorMessage: (state, action) => {
            state.modalErrorMessage = action.payload
        },
        setNotificationButtonLoad: (state, action) => {
            state.notificationButtonLoad = action.payload;
        },
        setModal401: (state, action) => {
            state.modal401 = action.payload;
        },
        addAlert: (state, action: PayloadAction<Alert>) => {
            state.alerts = [...state.alerts, action.payload]
        },
        removeAlert: (state, action: PayloadAction<string>) => {
            state.alerts = state.alerts.filter(x => x.id !== action.payload);
        },
        cleanAlerts: (state, action: PayloadAction<string>) => {
            state.alerts = state.alerts.filter(x => x.id !== action.payload);
        },
        addSpanErrorMessage: (state, action: PayloadAction<string>) => {
            state.spanErrorMessage = action.payload;
        },
        cleanSpanErrorMessage: (state) => {
            state.spanErrorMessage = "";
        }
    }
});

export const getNotification = (state: RootState) => state.notification.notificationInfo
export const getModalErrorStatus = (state: RootState) => state.notification.modalErrorStatus
export const getModalErrorMessage = (state: RootState) => state.notification.modalErrorMessage
export const getNotificationButtonLoad = (state: RootState) => state.notification.notificationButtonLoad
export const getmodal401 = (state: RootState) => state.notification.modal401
export const getSpanErrorMessage = (state: RootState) => state.notification.spanErrorMessage

// EXPORT DEFAULT
export const { cleanSpanErrorMessage, addSpanErrorMessage, setNotification, setResetNotification, setModalErrorStatus, setModalErrorMessage, setNotificationButtonLoad, setModal401 } = notificationSlice.actions
export default notificationSlice.reducer;